import { render } from "./WhiteBlockRounded.vue?vue&type=template&id=05864742&scoped=true"
import script from "./WhiteBlockRounded.vue?vue&type=script&lang=js"
export * from "./WhiteBlockRounded.vue?vue&type=script&lang=js"

import "./WhiteBlockRounded.vue?vue&type=style&index=0&id=05864742&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05864742"]])

export default __exports__